export default __webpack_public_path__ + "static/media/PLAIN_NICKEL_120x278_02_265.ccabda0a.jpg";